export default __webpack_public_path__ + "static/media/ClockIcon.d8504d53.svg";